<template>
  <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
    <!-- <ValidationObserver v-slot="{ invalid }"> -->
    <form action="#" @submit.prevent="changePassword">
      <div class>
        <label
          class="block text-grey-darker text-sm font-semibold mb-2"
          for="password"
        >{{ $t('OldPassword')}}</label>
        <input
          class="outline-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3 focus:border-teal-400"
          id="old-password"
          type="password"
          v-model="oldPassword"
          placeholder
        />
      </div>
      <div>
        <label class="block text-grey-darker text-sm font-semibold mb-2">{{ $t('NewPassword')}}</label>
        <input
          class="outline-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3 focus:border-teal-400"
          id="new-password"
          type="password"
          placeholder
          v-model="newPassword"
        />
      </div>
      <div>
        <label
          class="block text-grey-darker text-sm font-semibold mb-2"
          for="password"
        >{{ $t('ConfirmNewPassword')}}</label>
        <input
          class="outline-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3 focus:border-teal-400"
          id="confirm-new-password"
          type="password"
          placeholder
          v-model="confirmNewPassword"
        />
      </div>
      <div class="flex items-center justify-between">
        <button
          class="outline-none bg-teal-400 hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded hover:bg-white hover:text-teal-400"
          type="submit"
        >{{ $t('ChangePassword')}}</button>
        <router-link
          to="/profile"
          class="outline-none bg-teal-400 hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded hover:bg-white hover:text-teal-400"
        >{{ $t('Back') }}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      user: {},
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      newToken: "",
      errors: ""
    };
  },
  methods: {
    changePassword() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.newPassword === this.confirmNewPassword) {
        axios
          .post(`${process.env.VUE_APP_API}/pwdchange`, {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
          })
          .then(() => {
            this.$notify({
              group: "profile",
              title: "Profile",
              text: "Password update successfully"
            });
            this.$router.push("/");
            this.$store.dispatch("destroyToken");
          })
          .catch(error => console.log(error));
      }
    }
  }
};
</script>

<style>
</style>